"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyLabelSpins = void 0;
/*
 labels.ts
 to handle the layer orientation feature.
*/
const geometry_1 = require("./geometry");
const gOverlapTolerance = 1 / 100; // ~0 (for floating point)
function segmentOverlap(pMin1, pMax1, pMin2, pMax2) {
    let lOverlap = Math.max(0, Math.min(pMax1, pMax2) - Math.max(pMin1, pMin2));
    return lOverlap;
}
class Lane {
    constructor(boxes, bpo, pPallet) {
        this.bpo = bpo;
        this.box = boxes[bpo.index];
        const { x, y } = this.position;
        let { width, length, height } = this.box.dimensions;
        const mp = bpo.multipick || 0;
        if (bpo.multipickAlongWidth) {
            width *= mp + 1;
        }
        else {
            length *= mp + 1;
        }
        if (bpo.rotated) {
            const tmp = width;
            width = length;
            length = tmp;
        }
        width /= pPallet.Dimensions.width;
        length /= pPallet.Dimensions.length;
        // x, y position is top left coordinate.
        this.minX = x;
        this.maxX = x + width;
        this.minY = y;
        this.maxY = y + length;
        this.scaledDimensions = { width, length, height };
        this.intersection = {
            left: false,
            right: false,
            top: false,
            bottom: false,
        };
    }
    get labelSide() {
        if ('labelSide' in this.box)
            return this.box.labelSide;
        return geometry_1.LabelSide.None;
    }
    get labelSideAlt() {
        return this.box.labelSideAlt || geometry_1.LabelSide.None;
    }
    get position() {
        return this.bpo.position;
    }
    printBounds() {
        console.log(`X: [${this.minX}, ${this.maxX}], Y [${this.minY}, ${this.maxY}]`);
    }
    inYLane(pLane) {
        let lOverlap = segmentOverlap(this.minY, this.maxY, pLane.minY, pLane.maxY);
        // console.log('Y overlap', lOverlap);
        return lOverlap > gOverlapTolerance;
    }
    inXLane(pLane) {
        let lOverlap = segmentOverlap(this.minX, this.maxX, pLane.minX, pLane.maxX);
        // console.log('X overlap', lOverlap);
        return lOverlap > gOverlapTolerance;
    }
    intersect(pLane) {
        let [in_x_lane, in_y_lane] = [this.inXLane(pLane), this.inYLane(pLane)];
        // this.printBounds();
        // pLane.printBounds();
        // console.log(in_x_lane, in_y_lane);
        if (in_y_lane) {
            if (this.maxX > pLane.maxX) {
                this.intersection.left = true;
                pLane.intersection.right = true;
            }
            else {
                this.intersection.right = true;
                pLane.intersection.left = true;
            }
        }
        if (in_x_lane) {
            if (this.maxY > pLane.maxY) {
                // (higher Y values in svg coordinates are closer to the bottom)
                this.intersection.top = true;
                pLane.intersection.bottom = true;
            }
            else {
                this.intersection.bottom = true;
                pLane.intersection.top = true;
            }
        }
        // console.log(this.intersection);
    }
    // assumes clockwise rotation. (left side -> top, top -> right, right -> bottom,  bottom -> left)
    getBoxPosition() {
        this.bpo.spin = false;
        let lLabelSide = this.labelSide;
        const lAltSide = this.labelSideAlt;
        switch (lLabelSide) {
            case geometry_1.LabelSide.None:
                this.bpo.spin = false;
                break;
            case geometry_1.LabelSide.Left:
                if (lAltSide !== geometry_1.LabelSide.Right) {
                    /* if opposide side labels, ignore */
                    if (this.bpo.rotated) {
                        /* label on top */
                        if (this.intersection.top) {
                            if (!this.intersection.bottom ||
                                (lAltSide === geometry_1.LabelSide.Back &&
                                    this.intersection.right &&
                                    !this.intersection.left) ||
                                (lAltSide === geometry_1.LabelSide.Front &&
                                    this.intersection.left &&
                                    !this.intersection.right)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                    else {
                        if (this.intersection.left) {
                            if (!this.intersection.right ||
                                (lAltSide === geometry_1.LabelSide.Back &&
                                    this.intersection.top &&
                                    !this.intersection.bottom) ||
                                (lAltSide === geometry_1.LabelSide.Front &&
                                    this.intersection.bottom &&
                                    !this.intersection.top)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                }
                break;
            case geometry_1.LabelSide.Right:
                if (lAltSide !== geometry_1.LabelSide.Left) {
                    /* if opposite side labels, ignore */
                    if (this.bpo.rotated) {
                        /* label on bottom */
                        if (this.intersection.bottom) {
                            if (!this.intersection.top ||
                                (lAltSide === geometry_1.LabelSide.Back &&
                                    this.intersection.right &&
                                    !this.intersection.left) ||
                                (lAltSide === geometry_1.LabelSide.Front &&
                                    this.intersection.left &&
                                    !this.intersection.right)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                    else {
                        if (this.intersection.right) {
                            if (!this.intersection.left ||
                                (lAltSide === geometry_1.LabelSide.Back &&
                                    this.intersection.top &&
                                    !this.intersection.top) ||
                                (lAltSide == geometry_1.LabelSide.Front &&
                                    this.intersection.bottom &&
                                    !this.intersection.top)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                }
                break;
            case geometry_1.LabelSide.Back /* ie: top of box in overhead view 2D view */:
                if (lAltSide !== geometry_1.LabelSide.Front) {
                    /* if opposite side labels, ignore */
                    if (this.bpo.rotated) {
                        /* label on right */
                        if (this.intersection.right) {
                            if (!this.intersection.left ||
                                (lAltSide === geometry_1.LabelSide.Left &&
                                    this.intersection.top &&
                                    !this.intersection.bottom) ||
                                (lAltSide === geometry_1.LabelSide.Right &&
                                    this.intersection.bottom &&
                                    !this.intersection.top)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                    else {
                        if (this.intersection.top) {
                            if (!this.intersection.bottom ||
                                (lAltSide === geometry_1.LabelSide.Left &&
                                    this.intersection.left &&
                                    !this.intersection.top) ||
                                (lAltSide === geometry_1.LabelSide.Right &&
                                    this.intersection.right &&
                                    !this.intersection.left)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                }
                break;
            case geometry_1.LabelSide.Front /* ie: bottom of box in overhead 2D view  */:
                if (lAltSide !== geometry_1.LabelSide.Back) {
                    /* if opposite side labels, ignore */
                    if (this.bpo.rotated) {
                        /* label on left */
                        if (this.intersection.left) {
                            if (!this.intersection.right ||
                                (lAltSide === geometry_1.LabelSide.Left &&
                                    this.intersection.top &&
                                    !this.intersection.bottom) ||
                                (lAltSide === geometry_1.LabelSide.Right &&
                                    this.intersection.bottom &&
                                    !this.intersection.top)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                    else {
                        if (this.intersection.bottom) {
                            if (!this.intersection.top ||
                                (lAltSide === geometry_1.LabelSide.Left &&
                                    this.intersection.left &&
                                    !this.intersection.right) ||
                                (lAltSide === geometry_1.LabelSide.Right &&
                                    this.intersection.right &&
                                    !this.intersection.left)) {
                                this.bpo.spin = true;
                            }
                        }
                    }
                }
                break;
        }
        return this.bpo;
    }
}
function applyLabelSpins(boxes, layout, pPallet) {
    const lanes = layout.boxPositions.map((bpo) => new Lane(boxes, bpo, pPallet));
    for (let i = 0; i < lanes.length; i++) {
        let l1 = lanes[i];
        for (let j = i + 1; j < lanes.length; j++) {
            let l2 = lanes[j];
            l1.intersect(l2);
        }
    }
    layout.boxPositions = lanes.map(l => l.getBoxPosition());
}
exports.applyLabelSpins = applyLabelSpins;
